import { $api, type ProjectResponse } from "@/lib/api";
import { keepPreviousData } from "@tanstack/react-query";

interface ProjectQueryParams {
  skip?: number;
  limit?: number;
  accessToken?: string;
}

/**
 * Invalidation key for all project queries.
 * Matches the key format generated by $api.useQuery: ["get", "/api/v1/projects", ...].
 */
export const projectKeys = {
  all: ["get", "/api/v1/projects"] as const,
};

export type { ProjectResponse as Project };

export function useProjectsQuery(params: ProjectQueryParams) {
  const query: Record<string, number> = {};
  if (params.skip !== undefined) query.skip = params.skip;
  if (params.limit !== undefined) query.limit = params.limit;
  const init = Object.keys(query).length > 0
    ? { params: { query } }
    : undefined;

  return $api.useQuery("get", "/api/v1/projects", init, {
    staleTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
    enabled: !!params.accessToken,
  });
}
